var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _c("skp-breadcrumbs", {
          attrs: { setMenuId: _vm.myListMenuId },
          on: {
            "page-title": function(val) {
              return (_vm.pageTitle = val)
            }
          }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "pg_title" }, [_vm._v(_vm._s(_vm.pageTitle))]),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt10" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.BASIC.INFO")))
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "create_table" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.SUBSIDIARY"))),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { colspan: "3", "data-input-type": "select" } },
                [
                  _c(
                    "fieldset",
                    { staticClass: "ui_fieldset set_2 input-58" },
                    [
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.RHQ_CD,
                                expression: "RHQ_CD"
                              },
                              {
                                name: "validation",
                                rawName: "v-validation",
                                value: { groupId: "basic" },
                                expression: "{ groupId: 'basic' }"
                              }
                            ],
                            staticClass: "slt_white w100",
                            attrs: { id: "RHQ_CD", name: "RHQ_CD" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.RHQ_CD = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.changeRhqCd($event)
                                }
                              ]
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", disabled: "", selected: "" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME")
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.rhqCdList, function(item, index) {
                              return _c(
                                "option",
                                {
                                  key: item.code,
                                  domProps: { value: item.code }
                                },
                                [_vm._v(_vm._s(item.codeName))]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.CORP_NO,
                                expression: "CORP_NO"
                              },
                              {
                                name: "validation",
                                rawName: "v-validation",
                                value: { groupId: "basic" },
                                expression: "{ groupId: 'basic' }"
                              }
                            ],
                            staticClass: "slt_white w100",
                            attrs: { id: "CORP_NO", name: "CORP_NO" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.CORP_NO = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.changeCorpCd($event)
                                }
                              ]
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { value: "", disabled: "", selected: "" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME")
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.corpCdList, function(item, index) {
                              return _c(
                                "option",
                                {
                                  key: item.code,
                                  domProps: { value: item.code }
                                },
                                [_vm._v(_vm._s(item.codeName))]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))]),
              _vm._v(" "),
              _c("td", [
                _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.BOARD_TYPE1,
                            expression: "BOARD_TYPE1"
                          }
                        ],
                        staticClass: "slt_white w100",
                        attrs: { id: "BOARD_TYPE1", name: "BOARD_TYPE1" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.BOARD_TYPE1 = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.changeBoardType1($event)
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.boardType1List, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.boardType1List.length > 0,
                                  expression: "boardType1List.length > 0"
                                }
                              ],
                              key: item.code,
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.BOARD_TYPE2,
                            expression: "BOARD_TYPE2"
                          }
                        ],
                        staticClass: "slt_white w100",
                        attrs: { id: "BOARD_TYPE2", name: "BOARD_TYPE2" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.BOARD_TYPE2 = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.boardType2List, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.boardType2List.length > 0,
                                  expression: "boardType2List.length > 0"
                                }
                              ],
                              key: item.code,
                              attrs: {
                                "data-menu-grp-dtl-cd": item.menuGrpDtlCd
                              },
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.ADMIN.MENU.ORDER")))]),
              _vm._v(" "),
              _c("td", [
                _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.NEXT_ORDER1,
                            expression: "NEXT_ORDER1"
                          }
                        ],
                        staticClass: "slt_white w100",
                        attrs: { id: "NEXT_ORDER1", name: "NEXT_ORDER1" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.NEXT_ORDER1 = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              return _vm.changeOrder($event)
                            }
                          ]
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [_vm._v(_vm._s(_vm.$t("FIELD.NEXT.OF")))]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.nextOrder1List, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.nextOrder1List.length > 0,
                                  expression: "nextOrder1List.length > 0"
                                }
                              ],
                              key: item.code,
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.NEXT_ORDER2,
                            expression: "NEXT_ORDER2"
                          }
                        ],
                        staticClass: "slt_white w100",
                        attrs: { id: "NEXT_ORDER2", name: "NEXT_ORDER2" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.NEXT_ORDER2 = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [_vm._v(_vm._s(_vm.$t("FIELD.NEXT.OF")))]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.nextOrder2List, function(item) {
                          return _c(
                            "option",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.nextOrder2List.length > 0,
                                  expression: "nextOrder2List.length > 0"
                                }
                              ],
                              key: item.code,
                              domProps: { value: item.code }
                            },
                            [_vm._v(_vm._s(item.codeName))]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.BOARD.NAME.E"))),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.BOARD_NM_EN,
                      expression: "BOARD_NM_EN"
                    },
                    {
                      name: "validation",
                      rawName: "v-validation",
                      value: { groupId: "basic" },
                      expression: "{ groupId: 'basic' }"
                    }
                  ],
                  staticClass: "text_input w100",
                  attrs: {
                    type: "text",
                    id: "BOARD_NM_EN",
                    name: "BOARD_NM_EN",
                    placeholder: _vm.$t("FIELD.ADMIN.BOARD.NAME.E")
                  },
                  domProps: { value: _vm.BOARD_NM_EN },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.BOARD_NM_EN = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.BOARD.NAME.LOCAL"))),
                _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.BOARD_NM,
                      expression: "BOARD_NM"
                    },
                    {
                      name: "validation",
                      rawName: "v-validation",
                      value: { groupId: "basic" },
                      expression: "{ groupId: 'basic' }"
                    }
                  ],
                  staticClass: "text_input w100",
                  attrs: {
                    type: "text",
                    id: "BOARD_NM",
                    name: "BOARD_NM",
                    placeholder: _vm.$t("FIELD.ADMIN.BOARD.NAME.LOCAL")
                  },
                  domProps: { value: _vm.BOARD_NM },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.BOARD_NM = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.BOARD.DESCRIPTION.E")))
              ]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.BOARD_DESC_EN,
                      expression: "BOARD_DESC_EN"
                    }
                  ],
                  staticClass: "text_textarea w100",
                  attrs: {
                    placeholder: _vm.$t("FIELD.ADMIN.BOARD.DESCRIPTION.E")
                  },
                  domProps: { value: _vm.BOARD_DESC_EN },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.BOARD_DESC_EN = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.BOARD.DESCRIPTION.LOCAL")))
              ]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.BOARD_DESC,
                      expression: "BOARD_DESC"
                    }
                  ],
                  staticClass: "text_textarea w100",
                  attrs: {
                    placeholder: _vm.$t("FIELD.ADMIN.BOARD.DESCRIPTION.LOCAL")
                  },
                  domProps: { value: _vm.BOARD_DESC },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.BOARD_DESC = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.DISCAEDED.PERIOD")))
              ]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "3" } }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.DISCARDED_PERIOD,
                        expression: "DISCARDED_PERIOD",
                        modifiers: { number: true }
                      }
                    ],
                    staticClass: "slt_white input-58",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return _vm._n(val)
                          })
                        _vm.DISCARDED_PERIOD = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "", selected: "" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ALL")))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.discardedPreiodList, function(item) {
                      return _c(
                        "option",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.discardedPreiodList.length > 0,
                              expression: "discardedPreiodList.length > 0"
                            }
                          ],
                          key: item.code,
                          domProps: { value: item.code }
                        },
                        [_vm._v(_vm._s(item.codeName))]
                      )
                    })
                  ],
                  2
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt25" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.LIST.INFO")))
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "create_table" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.ADMIN.MAX.OF.COUNT")))]),
              _vm._v(" "),
              _c("td", { attrs: { "data-input-type": "input" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.LIST_CNT,
                      expression: "LIST_CNT",
                      modifiers: { number: true }
                    }
                  ],
                  staticClass: "text_input w100",
                  attrs: {
                    type: "number",
                    placeholder: _vm.$t("FIELD.ADMIN.MAX.OF.COUNT")
                  },
                  domProps: { value: _vm.LIST_CNT },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.LIST_CNT = _vm._n($event.target.value)
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "2" } })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }),
        _vm._v(" "),
        _c("div", { staticClass: "sub_tit mt25" }, [
          _vm._v(_vm._s(_vm.$t("SUBTITLE.GLOBAL.DETAIL.INFO")))
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "create_table" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.ADMIN.VERIFY")))]),
              _vm._v(" "),
              _c(
                "td",
                { attrs: { "data-input-type": "checkbox", colspan: "3" } },
                [
                  _c("label", { staticClass: "checkbox-wrap mr10" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.VERIFY_USE_YN,
                          expression: "VERIFY_USE_YN"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.VERIFY_USE_YN)
                          ? _vm._i(_vm.VERIFY_USE_YN, null) > -1
                          : _vm.VERIFY_USE_YN
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.VERIFY_USE_YN,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.VERIFY_USE_YN = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.VERIFY_USE_YN = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.VERIFY_USE_YN = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", { staticClass: "check-icon" }),
                    _vm._v(" "),
                    _c("em", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.USE")))])
                  ])
                ]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full topLine" }),
        _vm._v(" "),
        _c("div", { staticClass: "btn_wrap_full" }, [
          _c(
            "a",
            {
              staticClass: "btn_white size_full",
              attrs: { href: "javascript:" },
              on: { click: _vm.btnList }
            },
            [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LIST")))]
          ),
          _vm._v(" "),
          _vm.superUser === "Y"
            ? _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: { click: _vm.btnSave }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
                )
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c5926ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c5926ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/knowledgeManager/boardManage/BoardManageRegister.vue
// module id = cvqz
// module chunks = 0